import "../../style/scss/selectionPanel.scss";
import { DateTime } from "luxon";
import { MdCheckBoxOutlineBlank, MdOutlineCheckBox } from "react-icons/md";

export default function EmploymentSelectionListItem(props) {
  const startDate = props.employment.StartDate
    ? DateTime.fromISO(props.employment.StartDate).toFormat("MM / yyyy")
    : "";
  const endDate = props.employment.EndDate
    ? DateTime.fromISO(props.employment.EndDate).toFormat("MM / yyyy")
    : "Now";

  const onClick = (e) => {
    if (props.onClick) props.onClick(props.employment.ID, e);
    if (props.onChange) props.onChange(props.employment.ID, e);
  };

  const employers = props.employers || [];
  const client = employers.find((e) => e.ID === props.employment.ClientID);
  const intermediary = employers.find((e) => e.ID === props.employment.IntermediaryID);
  const employer = employers.find((e) => e.ID === props.employment.EmployerID);
  const name =
    (client || intermediary || employer)?.Name ||
    (client || intermediary || employer)?.ShortName ||
    "Employer";
  const title = props.employment.Title || props.employment.title || "";
  const dates = startDate ? `${startDate} – ${endDate}` : "";
  const versionOptions = Array.isArray(props.versionOptions) ? props.versionOptions : [];
  const selectedVersionIds = Array.isArray(props.selectedVersionIds)
    ? props.selectedVersionIds.map(Number)
    : [];
  const showVersions = props.selected && versionOptions.length > 0;

  return (
    <div
      className={
        "Job selectionPanel checkRow employment-select-item" +
        (props.selected ? " selected" : "")
      }
      id={props.employment.ID}
      role="checkbox"
      aria-checked={!!props.selected}
    >
      <div className="employment-select-item__row" onClick={onClick}>
        <span className="icon">
          <MdCheckBoxOutlineBlank
            size={22}
            className={props.selected ? "hidden" : ""}
            aria-hidden
          />
          <MdOutlineCheckBox
            size={22}
            className={props.selected ? "" : "hidden"}
            aria-hidden
          />
        </span>
        <div className="employment-select-item__body">
          <span className="title">{name}</span>
          {title ? <span className="byline">{title}</span> : null}
          {dates ? <span className="rightText">{dates}</span> : null}
        </div>
      </div>
      {showVersions ? (
        <div
          className="employment-select-item__versions"
          data-testid={`employment-versions-${props.employment.ID}`}
          onClick={(e) => e.stopPropagation()}
        >
          <span className="employment-select-item__versions-label">Versions used</span>
          <div className="employment-select-item__version-chips">
            {versionOptions.map((v) => {
              const vid = Number(v.ID ?? v.id);
              const label = v.Version ?? v.version ?? String(vid);
              const checked = selectedVersionIds.includes(vid);
              return (
                <label key={vid} className={checked ? "is-checked" : undefined}>
                  <input
                    type="checkbox"
                    checked={checked}
                    onChange={() => props.onToggleVersion?.(props.employment.ID, vid)}
                  />
                  {label}
                  {v.IsLts || v.isLts ? " LTS" : ""}
                </label>
              );
            })}
          </div>
          <p className="employment-select-item__versions-hint">
            Leave unchecked if you used the skill but are not sure which release.
          </p>
        </div>
      ) : null}
    </div>
  );
}
